export default __webpack_public_path__ + "static/media/DateTimeFrequency.3c21a5e9.svg";